import https from 'https';
import store from '@/store/index';
import bizTransport from '@/modules/bizTransport';
import logger from '@/modules/Logger';
import { Message } from 'element-ui';
import { internetWarning, internetError } from '@/utils/constants';
import { isBrowserSupportsNetworkInfo } from '@/utils/common';

class DetectSpeed {
  constructor() {
    const baseUrl = window.location.protocol + '//' + window.location.host;
    this.errorMsg = null;
    this.errorMsgInterval = 300000; // every 5 minutes
    this.displayedAt = 0;
    this.minimumRequirement = 2000; // KBPS
    this.remoteImage = {
      path: baseUrl + '/assets/upload/speed-test-sample.jpg',
      size: 171347
    }
  }

  getFileUrl() {
    return this.remoteImage.path + '?_=' + new Date().getTime();
  }

  speed() {
    let startTime;
    return new Promise((resolve, reject) => {
      return https.get(this.getFileUrl(), response => {
        if (response.statusCode !== 200) {
          reject('Problem downloading image for speed testing ' + this.remoteImage.path);
        }

        response.once('data', () => {
          startTime = new Date().getTime();
        });

        response.once('end', () => {
          const endTime = new Date().getTime();
          const duration = (endTime - startTime) / 1000;
          const bitsLoaded = this.remoteImage.size * 8;
          const kbps = ((bitsLoaded / duration) / 1000).toFixed(0);
          resolve(kbps);
        });
      });
    }).catch(err => {
      logger.error('Internet speed test error',
        { 
          operation: 'utils:internet',
          reason: err,
          event_type:21
        }
      );
    });
  }

  getSpeed() {
    return new Promise(async (resolve) => {
      let speedResults = 0;
      if (isBrowserSupportsNetworkInfo()) {
        speedResults = navigator.connection.downlink * 1000;
      } else {
        speedResults = await this.speed();
      }

      this.sendInternetLog(speedResults);
      resolve(speedResults);
    }).catch(err => {
      logger.error('Internet speed test error getSpeed',
        { 
          operation: 'utils:internet',
          reason: err,
          event_type:21
        }
      );
    });
  }

  generateSpeedData() {
    return new Promise(async (resolve) => {
      const speedResults = await this.speed();
      resolve(speedResults);
    });
  }

  setErrorMsg(msg) {
    this.errorMsg = msg;
    return this;
  }

  displayMessage() {
    if (!this.errorMsg) {
      return true;
    }

    const difference = new Date().getTime() - this.displayedAt;
    return difference > this.errorMsgInterval;
  }

  showMessage() {
    this.displayedAt = new Date().getTime();
    Message({
      duration: 10000,
      showClose: true,
      message: this.errorMsg,
      type: 'error'
    });
  }

  async speedStatus() {
    const results = await this.generateSpeedData();
    
    const consolebizTransport = new bizTransport(store.getters.logTransportToken);
    logger.add(consolebizTransport);
    
    logger.info('Checking internet speed', { operation: 'utils:internet' });
    if (results < this.minimumRequirement && this.displayMessage()) {
      if (this.errorMsg) {
        this.showMessage();
      }
    }

    this.sendInternetLog(results);
    logger.remove(consolebizTransport);
  }

  sendInternetLog(speed) {
    if (speed < internetError) {
      logger.error(`Unstable internet connection, current user with ${speed} kbps (minimum recommended requirement of ${this.minimumRequirement} kbps)`, { operation: 'utils:internet', event_type:23 });
      return true;
    }
  
    if (speed < internetWarning) {
      logger.warn(`Unstable internet connection, current user with ${speed} kbps (minimum recommended requirement of ${this.minimumRequirement} kbps)`, { operation: 'utils:internet' });
      return true;
    }
    
    logger.info(`Internet speed of ${speed} kbps (minimum requirement of ${this.minimumRequirement} kbps)`, { operation: 'utils:internet' });
    return true;
  }
}

let detectSpeed = new DetectSpeed();

export default detectSpeed;
